import { render, staticRenderFns } from "./SymbolsChooser.vue?vue&type=template&id=199a0d6d&scoped=true"
import script from "./SymbolsChooser.vue?vue&type=script&lang=js"
export * from "./SymbolsChooser.vue?vue&type=script&lang=js"
import style0 from "./SymbolsChooser.vue?vue&type=style&index=0&id=199a0d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a0d6d",
  null
  
)

export default component.exports